"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dark = exports.light = void 0;
const createMuiTheme_1 = __importDefault(require("@material-ui/core/styles/createMuiTheme"));
const responsiveFontSizes_1 = __importDefault(require("@material-ui/core/styles/responsiveFontSizes"));
require("./global.scss");
const headingFontFamily = ["Overpass", "serif"].join(",");
const lightTheme = {
    overrides: {
        MuiCssBaseline: {
            "@global": {
                html: {
                    WebkitFontSmoothing: "auto",
                },
            },
        },
    },
    typography: {
        fontFamily: ["Open Sans", "sans-serif"].join(","),
        fontSize: 18,
        h1: {
            fontFamily: headingFontFamily,
            fontSize: "3rem",
            fontWeight: 700,
        },
        h2: {
            fontFamily: headingFontFamily,
            fontSize: "2.5rem",
            fontWeight: 700,
        },
        h3: {
            fontFamily: headingFontFamily,
            fontSize: "2rem",
            fontWeight: 700,
        },
        h4: {
            fontFamily: headingFontFamily,
            fontSize: "1.25rem",
            fontWeight: 700,
        },
        h5: {
            fontFamily: headingFontFamily,
            fontSize: "1rem",
            fontWeight: 700,
        },
        h6: {
            fontFamily: headingFontFamily,
            fontSize: "1rem",
            fontWeight: 400,
            textDecoration: "underline",
        },
    },
    palette: {
        primary: {
            main: "#13294b",
        },
        secondary: {
            main: "#e84a27",
        },
        text: {
            primary: "#444444",
        },
    },
};
const darkTheme = Object.assign({}, lightTheme, {
    palette: {
        type: "dark",
        text: {
            primary: "#CCCCCC",
        },
    },
});
exports.light = responsiveFontSizes_1.default(createMuiTheme_1.default(lightTheme));
exports.dark = responsiveFontSizes_1.default(createMuiTheme_1.default(darkTheme));
//# sourceMappingURL=theme.js.map